import { leadForwardingProjectSchema } from "./leadForwardingProjectSchema";
import { z } from "zod";

export const getOpportunitiesPathParamsSchema = z.object({
  partnerId: z.coerce
    .string()
    .regex(/^[a-zA-Z0-9]+$/)
    .min(1)
    .max(20)
    .describe(
      "Identifier of the partner to query. iLOQ inc -partners have US-prefix in their partnerId.",
    ),
});

export type GetOpportunitiesPathParams = z.infer<typeof getOpportunitiesPathParamsSchema>;

export const getOpportunitiesQueryParamsSchema = z.object({
  currency: z.coerce.string(),
});

export type GetOpportunitiesQueryParams = z.infer<typeof getOpportunitiesQueryParamsSchema>;

/**
 * @description Contains list of lead forwarding projects
 */
export const getOpportunities200Schema = z.array(z.lazy(() => leadForwardingProjectSchema));

export type GetOpportunities200 = z.infer<typeof getOpportunities200Schema>;

/**
 * @description 500 - Internal server error
 */
export const getOpportunities500Schema = z.unknown();

export type GetOpportunities500 = z.infer<typeof getOpportunities500Schema>;

export const getOpportunitiesQueryResponseSchema = z.lazy(() => getOpportunities200Schema);

export type GetOpportunitiesQueryResponse = z.infer<typeof getOpportunitiesQueryResponseSchema>;
